// extracted by mini-css-extract-plugin
export var cols1 = "Columns-module--cols1--d3687";
export var cols2 = "Columns-module--cols2--44719";
export var cols3 = "Columns-module--cols3--baab7";
export var cols4 = "Columns-module--cols4--3fb74";
export var columns = "Columns-module--columns--71eb9";
export var isReverse = "Columns-module--isReverse--54ed5";
export var item = "Columns-module--item--7647d";
export var showBorders = "Columns-module--showBorders--78618";